/**
 * Company: PwC
 * Description:
 *   Account -> Personal Contacts + Medical Contacts (637)
 *   Find a Location - Location Details (349)
 *   [SIT] User Account/Profile Updates (925)
 * History:
 * [2023/12/11] William Cheng - New
 */

import ehIconMessagesSvg from 'images/custom/icons/eh-icon-messages.svg'
import ehIconBookAVisitSvg from 'images/custom/icons/eh-icon-book-a-visit.svg'
import ehIconMyHealthSvg from 'images/custom/icons/eh-icon-my-health.svg'

import ehIconHomeSvg from 'images/custom/icons/eh-icon-home.svg'
import ehIconProvidersSvg from 'images/custom/icons/eh-icon-providers.svg'
import ehIconLocationSvg from 'images/custom/icons/eh-icon-location.svg'
import ehIconLocationsSvg from 'images/custom/icons/eh-icon-locations.svg'
import ehIconVisitsSvg from 'images/custom/icons/eh-icon-visits.svg'

import ehIconIdentitySvg from 'images/custom/icons/eh-icon-identity.svg'
import ehIconMedicalContactSvg from 'images/custom/icons/eh-icon-medical-contact.svg'
import ehIconLogCallSvg from 'images/custom/icons/eh-icon-log-a-call.svg'
import ehIconNotebookSvg from 'images/custom/icons/eh-icon-notebook.svg'
import ehIconPaymentMethodsSvg from 'images/custom/icons/eh-icon-payment-methods.svg'
import ehIconInsuranceSvg from 'images/custom/icons/eh-icon-insurance.svg'
import ehIconEligibilitySvg from 'images/custom/icons/eh-icon-eligibility.svg'
import ehIconClaimsSvg from 'images/custom/icons/eh-icon-claims.svg'
import ehIconFamilyDeductibleStatusSvg from 'images/custom/icons/eh-icon-family-deductible-status.svg'

import ehIconReferralsSvg from 'images/custom/icons/eh-icon-referrals.svg'
import ehIconTestResultsSvg from 'images/custom/icons/eh-icon-test-results.svg'
import ehIconMedicationsSvg from 'images/custom/icons/eh-icon-medications.svg'
import ehIconImmunizationsSvg from 'images/custom/icons/eh-icon-immunizations.svg'
import ehIconAllergiesSvg from 'images/custom/icons/eh-icon-allergies.svg'
import ehIconHealthConditionsSvg from 'images/custom/icons/eh-icon-health-conditions.svg'
import ehIconProceduresSvg from 'images/custom/icons/eh-icon-procedures.svg'
import ehIconSocialHistorySvg from 'images/custom/icons/eh-icon-social-history.svg'
import ehIconFamilyHistorySvg from 'images/custom/icons/eh-icon-family-history.svg'
import ehIconCarePlan from 'images/custom/icons/eh-icon-care-plan.svg'
import ehIconradiology from 'images/custom/icons/eh-icon-radiology.svg'
import ehIconMicrobiology from 'images/custom/icons/eh-icon-microbiology.svg'
import ehIconAllScripts from 'images/custom/icons/eh-icon-allscripts.svg'
import ehIconCerner from 'images/custom/icons/eh-icon-cerner.svg'
import ehIconEpic from 'images/custom/icons/eh-icon-epic.svg'
import ehIconGoogleFit from 'images/custom/icons/eh-icon-googlefit.svg'
import ehIconHealthKit from 'images/custom/icons/eh-icon-healthkit.svg'
import ehIconFilter from 'images/custom/icons/eh-icon-filter.svg'
import ehTeleAppts from 'images/custom/icons/eh-icon-telehealth.svg'

// PROVIDER
import ehIconProviderNetwork from 'images/custom/icons/provider/eh-icon-provider-network.svg'
import ehIconProviderOutOfNetwork from 'images/custom/icons/provider/eh-icon-provider-outofnetwork.svg'

// LOCATIONS
import ehNoGeoIcon from 'images/custom/icons/locations/icon-no-geo.svg'
import ehIconNewWindowSvg from 'images/custom/icons/locations/eh-icon-new-window.svg'
// COMMON
import ehIconPdf from 'images/custom/icons/common/eh-icon-pdf.svg'

// MORE MENU
import ehIconSymptomChecker from 'images/custom/icons/moreMenu/eh-icon-symptom-checker.svg'
import ehIconAbout from 'images/custom/icons/moreMenu/eh-icon-about.svg'
import ehIconAccountSvg from 'images/custom/icons/moreMenu/eh-icon-account.svg'
import ehIconBillPaySvg from 'images/custom/icons/moreMenu/eh-icon-billpay.svg'
import ehIconSettingsSvg from 'images/custom/icons/moreMenu/eh-icon-settings.svg'
import ehIconGetCare from 'images/custom/icons/moreMenu/eh-icon-getcare.svg'
import ehIconLogout from 'images/custom/icons/moreMenu/eh-icon-logout.svg'
import ehIconResources from 'images/custom/icons/moreMenu/eh-icon-resources.svg'
import ehIconSignIn from 'images/custom/icons/moreMenu/eh-icon-signin.svg'
import ehIconHelp from 'images/custom/icons/moreMenu/eh-icon-help.svg'
import ehIconPrivacy from 'images/custom/icons/moreMenu/eh-icon-privacy.svg'
import ehIconContact from 'images/custom/icons/moreMenu/eh-icon-contact.svg'
import ehIconRequestMedical from 'images/custom/icons/moreMenu/eh-icon-request-medical.svg'

// VIDEO SESSION
import ehIconCameraSwitch from 'images/custom/icons/videoSession/eh-icon-camswitch.svg'
import ehIconVideoCamera from 'images/custom/icons/videoSession/eh-icon-cam.svg'
import ehIconMic from 'images/custom/icons/videoSession/eh-icon-mic.svg'

// BOTTOM TAB
import ehIconMore from 'images/custom/icons/bottomTabNavigator/eh-icon-more.svg'
import ehIconLogo from 'images/custom/icons/bottomTabNavigator/eh-icon-logo.svg'

// COMMON
import ehIconBellSvg from 'images/custom/icons/eh-icon-notifications.svg'
import ehIconVirtualVisit from 'images/custom/icons/common/eh-icon-virutalvisit.svg'

// import ehIconCalendarSvg from 'images/custom/icons/eh-icon-calendar.svg'
import ehIconCallSvg from 'images/custom/icons/eh-icon-call.svg'
import ehIconCameraSvg from 'images/custom/icons/eh-icon-camera.svg'
import ehIconChevronSvg from 'images/custom/icons/eh-icon-chevron.svg'
import ehIconChevronLeftSvg from 'images/custom/icons/eh-icon-chevron-left.svg'
import ehIconChevronRightSvg from 'images/custom/icons/eh-icon-chevron-right.svg'
import ehIconClearSvg from 'images/custom/icons/eh-icon-clear.svg'
import ehIconCloseSvg from 'images/custom/icons/eh-icon-close.svg'
import ehIconConfirmedSvg from 'images/custom/icons/eh-icon-confirmed.svg'
import ehIconEditSvg from 'images/custom/icons/eh-icon-edit.svg'
import ehIconSearchSvg from 'images/custom/icons/eh-icon-search.svg'
import ehIconSwitchSvg from 'images/custom/icons/eh-icon-switch.svg'
import ehIcondocuments from 'images/custom/icons/eh-icon-request-documents.svg'

import enIconVisitCancel from 'images/custom/icons/eh-icon-visit-cancel.svg'
import enIconVisitSummary from 'images/custom/icons/eh-icon-visit-summary.svg'
import enIconVisitReschedule from 'images/custom/icons/eh-icon-visit-reschedule.svg'

import enIconAppointmentCanceled from 'images/custom/icons/eh-icon-appointment-canceled.svg'
import ehIconSendMessage from 'images/custom/icons/eh-icon-send-message.svg'
import ehIconChat from 'images/custom/icons/eh-icon-chat.svg'
import ehIconPhone from 'images/custom/icons/eh-icon-phone.svg'
import ehIconPhoneDisabled from 'images/custom/icons/eh-icon-phone-disabled.svg'
import ehIconCompose from 'images/custom/icons/eh-icon-compose.svg'
import ehIconCheckin from 'images/custom/icons/eh-icon-checkin.svg'
import ehIconComposeDark from 'images/custom/icons/eh-icon-compose-dark.svg'
import ehIconPhoneDark from 'images/custom/icons/eh-icon-phone-dark.svg'

// PROVIDER
export const IconProviderNetwork = ehIconProviderNetwork
export const IconProviderOutOfNetwork = ehIconProviderOutOfNetwork

// LOCATIONS
export const IconNoGeo = ehNoGeoIcon
export const IconNewWindow = ehIconNewWindowSvg
// COMMON
export const IconPdf = ehIconPdf

// MORE MENU
export const IconSymptomChecker = ehIconSymptomChecker
export const IconAccount = ehIconAccountSvg
export const IconBillPay = ehIconBillPaySvg
export const IconSettings = ehIconSettingsSvg
export const IconAbout = ehIconAbout
export const IconGetCare = ehIconGetCare
export const IconLogout = ehIconLogout
export const IconResources = ehIconResources
export const IconSignIn = ehIconSignIn
export const IconHelp = ehIconHelp
export const IconPrivacy = ehIconPrivacy
export const IconContact = ehIconContact
export const IconRequestMedical = ehIconRequestMedical

// VIDEO SESSION
export const IconCameraSwitch = ehIconCameraSwitch
export const IconVideoCamera = ehIconVideoCamera
export const IconMic = ehIconMic

// BOTTOM TAB
export const IconMore = ehIconMore
export const IconLogo = ehIconLogo

// COMMON
export const IconBell = ehIconBellSvg
export const IconVirtualVisit = ehIconVirtualVisit

export const IconVisitCancel = enIconVisitCancel
export const IconVisitSummary = enIconVisitSummary
export const IconVisitReschedule = enIconVisitReschedule
export const IconSendMessage = ehIconSendMessage

export const IconAppointmentCanceled = enIconAppointmentCanceled

export const IconMessages = ehIconMessagesSvg
export const IconBookAVisit = ehIconBookAVisitSvg
export const IconMyHealth = ehIconMyHealthSvg

export const IconHome = ehIconHomeSvg
export const IconProviders = ehIconProvidersSvg
export const IconLocation = ehIconLocationSvg
export const IconLocations = ehIconLocationsSvg
export const IconVisits = ehIconVisitsSvg

export const IconIdentity = ehIconIdentitySvg
export const IconLogCall = ehIconLogCallSvg
export const IconNotebook = ehIconNotebookSvg
export const IconMedicalContact = ehIconMedicalContactSvg
export const IconPaymentMethods = ehIconPaymentMethodsSvg
export const IconInsurance = ehIconInsuranceSvg
export const IconEligibility = ehIconEligibilitySvg
export const IconClaims = ehIconClaimsSvg
export const IconFamilyDeductibleStatus = ehIconFamilyDeductibleStatusSvg

export const IconReferrals = ehIconReferralsSvg
export const IconTestResults = ehIconTestResultsSvg
export const IconMedications = ehIconMedicationsSvg
export const IconImmunizations = ehIconImmunizationsSvg
export const IconAllergies = ehIconAllergiesSvg
export const IconHealthConditions = ehIconHealthConditionsSvg
export const IconProcedures = ehIconProceduresSvg
export const IconSocialHistory = ehIconSocialHistorySvg
export const IconFamilyHistory = ehIconFamilyHistorySvg
export const IconCarePlan = ehIconCarePlan

export const IconAllScripts = ehIconAllScripts
export const IconCerner = ehIconCerner
export const IconEpic = ehIconEpic
export const IconGoogleFit = ehIconGoogleFit
export const IconHealthKit = ehIconHealthKit
export const IconFilter = ehIconFilter
export const IconTeleAppts = ehTeleAppts

// export const IconCalendar = ehIconCalendarSvg)
export const IconCall = ehIconCallSvg
export const IconCamera = ehIconCameraSvg
export const IconChevron = ehIconChevronSvg
export const IconChevronLeft = ehIconChevronLeftSvg
export const IconChevronRight = ehIconChevronRightSvg
export const IconClear = ehIconClearSvg
export const IconClose = ehIconCloseSvg
export const IconConfirmed = ehIconConfirmedSvg
export const IconEdit = ehIconEditSvg
export const IconSearch = ehIconSearchSvg
export const IconSwitch = ehIconSwitchSvg

export const IconRadiology = ehIconradiology
export const IconDocuments = ehIcondocuments
export const IconMicrobiology = ehIconMicrobiology

// ChatBot
export const IconChatbot = ehIconChat

// appointment actions
export const IconPhone = ehIconPhone
export const IconPhoneDisabled = ehIconPhoneDisabled
export const IconCompose = ehIconCompose
export const IconCheckin = ehIconCheckin
export const IconComposeDark = ehIconComposeDark
export const IconPhoneDark = ehIconPhoneDark
